import React from 'react';
import { Card, Box, Typography, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface IndustrySummaryCardProps {
  title: string;
  value: string;
  bgColor: string;
  tooltip?: string;
}

const IndustrySummaryCard: React.FC<IndustrySummaryCardProps> = ({ title, value, bgColor, tooltip }) => {
  return (
    <Card elevation={0} sx={{ p: 3, borderRadius: 2, bgcolor: bgColor, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 'bold' }}>{title}</Typography>
            {tooltip && (
                <Tooltip title={tooltip} arrow>
                    <InfoIcon fontSize="small" color="action" sx={{ cursor: 'help', fontSize: 16, opacity: 0.7 }} />
                </Tooltip>
            )}
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'text.primary' }}>{value}</Typography>
    </Card>
  );
};

export default IndustrySummaryCard;
